var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#40B3DB",
    d: "M13.1874781,7.20315551 C13.1874781,7.74456848 13.6304378,8.18752816 14.1718507,8.18752816 L19.7499624,8.18752816 L19.7499624,21.6406211 C19.7499624,22.1861196 19.3110883,22.6249937 18.7655898,22.6249937 L4.98437265,22.6249937 C4.43887415,22.6249937 4,22.1861196 4,21.6406211 L4,2.60941646 C4,2.06391796 4.43887415,1.62504381 4.98437265,1.62504381 L13.1874781,1.62504381 L13.1874781,7.20315551 Z M16.3231232,15.8722118 C16.7386056,15.4591726 16.4465703,14.7500125 15.8608573,14.7500125 L13.1874781,14.7500125 L13.1874781,11.4687703 C13.1874781,11.1061995 12.8938005,10.8125219 12.5312297,10.8125219 L11.2187328,10.8125219 C10.8561619,10.8125219 10.5624844,11.1061995 10.5624844,11.4687703 L10.5624844,14.7500125 L7.88910511,14.7500125 C7.30339216,14.7500125 7.0113568,15.4591726 7.42768043,15.8722118 L11.3823944,19.7973657 C11.6551236,20.0684927 12.09564,20.0684927 12.3684092,19.7973657 L16.3231232,15.8722118 Z M19.4628538,5.93167417 C19.6474236,6.11624404 19.7499624,6.36642273 19.7499624,6.6248526 L19.7499624,6.87503129 L14.499975,6.87503129 L14.499975,1.62504381 L14.7501537,1.62504381 C15.0126691,1.62504381 15.2628478,1.72758263 15.4474176,1.9121525 L19.4628538,5.93167417 Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.8e8a239f.svg";
export { ForwardRef as ReactComponent };